import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const ja = {
  common: {
    appName: "StepHub HR",
    login: "ログイン", logout: "ログアウト", email: "メールアドレス", password: "パスワード",
    save: "保存", cancel: "キャンセル", submit: "提出", edit: "編集", delete: "削除",
    approve: "承認", reject: "却下", return: "差戻し", loading: "読み込み中...",
    home: "ホーム", dashboard: "ダッシュボード", back: "戻る", search: "検索", export: "エクスポート",
    total: "合計", status: "ステータス", actions: "操作", date: "日付", remarks: "備考",
    yes: "はい", no: "いいえ", pending: "承認待ち", approved: "承認済み", rejected: "却下", returned: "差戻し", draft: "下書き", submitted: "提出済",
    languageJa: "日本語", languageEn: "English", loginTitle: "ログインして開始", welcome: "ようこそ",
    all: "すべて", month: "月", year: "年", none: "なし",
    changePassword: "パスワード変更", currentPassword: "現在のパスワード", newPassword: "新しいパスワード",
    confirmPassword: "パスワード（確認）", pwMismatch: "新しいパスワードが一致しません",
    pwChanged: "パスワードを変更しました", confirm: "確認", copy: "コピー", copied: "コピーしました",
    note: "備考・コメント", requiredNote: "差戻しの理由を入力してください",
    week: "第",
    download: "ダウンロード", openInNewTab: "新しいタブで開く",
    receipt: "領収書", noPreview: "この形式ではプレビューできません。ダウンロードしてご確認ください。",
    downloadZip: "領収書ZIPダウンロード", zipEmpty: "対象の領収書がありません",
    zipDone: "{{count}} 件の領収書をダウンロードしました",
    zipPreparing: "ZIPを作成中...",
    announcements: "お知らせ",
    includeStatus: "対象データ", statusApprovedOnly: "承認済みのみ", statusApprovedSubmitted: "承認済み + 提出済み",
    view: "詳細", saveChanges: "変更を保存",
    phoneNumber: "電話番号", licenseValidTill: "免許有効期限", hotelMode: "ホテルモード",
    incentive: "インセンティブ", gender: "性別", nationality: "国籍",
    joiningDate: "入社日", relievingDate: "退職日", remarks: "備考",
    male: "男性", female: "女性", other: "その他", unspecified: "未指定",
    yes: "はい", no: "いいえ",
    checkExpenses: "経費チェック", checking: "チェック中...", checkColumn: "OCRチェック",
    ocrOk: "OK", ocrMismatch: "金額相違", ocrNoReceipt: "領収書なし",
    ocrFailed: "OCR失敗", ocrManualReview: "手動確認", ocrNotChecked: "未チェック",
    approveAlertTitle: "経費チェック不一致",
    approveAlertBody: "{{date}} の経費でOCR結果と一致しません。\n{{note}}",
    forceApprove: "強制承認", cancelApprove: "承認キャンセル",
    dateOfBirth: "生年月日", age: "年齢", nameEn: "氏名（英語）", address: "住所",
    required: "必須", requiredFields: "以下の必須項目を入力してください: {{fields}}",
    saved: "保存しました", submitted: "提出しました",
    mandatoryHint: "* は必須項目です",
  },
  driver: {
    home: "ホーム", clockIn: "出勤", clockOut: "退勤", registerExpense: "経費登録",
    uploadReceipt: "領収書アップロード", history: "履歴", todayAttendance: "本日の勤怠", todayExpenses: "本日の経費",
    monthlyHours: "月間労働時間", monthlyExpense: "月間経費", pendingApprovals: "承認待ち",
    startTime: "開始時刻", endTime: "終了時刻", breakMinutes: "休憩(分)", workingHours: "労働時間",
    submitAttendance: "勤怠を提出", saveDraft: "下書き保存", noRecords: "記録がありません",
    category: "カテゴリ", description: "説明", amount: "金額", fuel: "ガソリン代", toll: "高速料金", meal: "食事手当", other: "その他",
    submitExpense: "経費を提出", myExpenses: "自分の経費", myAttendance: "自分の勤怠",
    downloadReport: "レポートをダウンロード", excel: "Excel", pdf: "PDF",
    receiptsFor: "領収書",
    registerAttendance: "勤怠を登録",
    editingExpense: "経費を編集", editingRecord: "この経費を編集しています",
    saveChanges: "変更を保存", updateAndSubmit: "更新して提出", editAndResubmit: "編集して再提出",
    resubmitted: "再提出しました", saved: "保存しました",
    returnedHint: "差戻しされています。内容を修正して再提出してください。",
    rejectedHint: "却下されています。",
    approvedHint: "承認済みのため編集できません。",
    submitted: "提出しました",
    savedDraft: "下書きを保存しました",
    carNumber: "車番",
    kilometers: "走行距離 (km)",
    standbyLabel: "本日は待機（standby）です",
    rulesTitle: "勤怠ルール",
    rule1: "1日の勤務は最大 8時間。残業には承認が必要です。",
    rule2: "昼休憩は 1時間 必ずお取りください。",
    rule3: "「待機」の場合は、備考欄にコメントを必ずご記入ください。",
    rulesStandbyRequired: "待機の場合は備考欄にコメントを入力してください。",
    warnHours: "8時間を超えています。承認が必要です。",
    warnBreak: "休憩時間が1時間未満です。",
  },
  admin: {
    dashboard: "管理ダッシュボード", employees: "従業員管理", attendance: "勤怠レビュー",
    expenses: "経費レビュー", reports: "レポート", totalEmployees: "全従業員",
    submittedToday: "本日の勤怠提出", missing: "未提出", pendingAtt: "承認待ち勤怠", pendingExp: "承認待ち経費",
    monthlyExpenseSummary: "月別経費サマリ", addEmployee: "従業員を追加", empCode: "従業員ID", name: "氏名",
    department: "部署", position: "役職", employmentStatus: "在職状況", joinDate: "入社日",
    role: "ロール", roleDriver: "ドライバー", roleReportViewer: "レポート閲覧者", roleHrAdmin: "HR管理者",
    roleHint: "「レポート閲覧者」は経理・給与担当向け。レポートのダウンロードのみ可能です。",
    monthlySummary: "月次サマリ (Excel)", perEmployee: "従業員別レポート",
    reviewNote: "レビュー備考", filterStatus: "ステータス絞り込み", filterEmployee: "従業員絞り込み",
    filterCategory: "カテゴリ絞り込み",
    seedDemo: "デモデータを投入", seedDemoHint: "5名のドライバーと約1ヶ月のサンプル勤怠・経費を作成します",
    seeding: "投入中...", seedDone: "デモデータを投入しました", seedFailed: "投入に失敗しました",
    reportType: "レポート種別", reportBoth: "勤怠＋経費", reportAttendance: "勤怠のみ", reportExpense: "経費のみ",
    activate: "有効化", deactivate: "無効化", resetPassword: "パスワードをリセット",
    resetPasswordTitle: "パスワードをリセットしました", resetPasswordHint: "この新しいパスワードは1度だけ表示されます。従業員にメール等で伝えてください。",
    confirmDeactivate: "この従業員を無効化しますか？", confirmActivate: "この従業員を有効化しますか？",
    confirmResetPassword: "この従業員のパスワードをリセットしますか？",
    selectAll: "全選択", clearSelection: "選択解除", approveSelected: "選択を承認",
    confirmBulkApprove: "選択した {{count}} 件を承認しますか？",
    bulkApproveDone: "{{count}} 件を承認しました",
    noSelection: "対象を選択してください",
    employeeHoursTitle: "従業員別 月間労働時間",
    reportDaysWorked: "労働日数",
    mealWeeklyTitle: "食事手当 週次サマリ",
    mealWeeklyHint: "¥6,000〜¥9,000/週 は基準内 (緑)。¥9,000超は上限超過 (赤)。",
    mealOk: "基準内",
    mealOver: "上限超過",
    mealUnder: "基準未満",
    notifications: "お知らせ",
    notifSub: "ドライバーのダッシュボードに表示される通知を管理します。",
    notifNew: "新しいお知らせを投稿",
    notifPlaceholder: "例: 明日は臨時のミーティングが 10:00 にあります。",
    notifPost: "投稿する",
    notifRequired: "メッセージを入力してください",
    notifPosted: "お知らせを投稿しました",
    notifList: "現在のお知らせ",
    notifEmpty: "お知らせはまだありません。",
    notifConfirmDelete: "このお知らせを削除しますか？",
    expenseCategories: "経費カテゴリ管理",
    expenseCategoriesSub: "経費カテゴリを追加・削除・並び替えできます。並び順はフォームや集計での表示順に反映されます。",
    catNew: "新しいカテゴリを追加",
    catList: "登録済みカテゴリ",
    catCode: "コード",
    catCodeHint: "半角英数の内部識別子（例: fuel, parking）。作成後は変更できません。",
    catLabelJa: "日本語ラベル",
    catLabelEn: "英語ラベル",
    catShowInactive: "無効化済みも表示",
    catAllFieldsRequired: "すべての項目を入力してください",
    catCreated: "カテゴリを追加しました",
    catDeleted: "カテゴリを無効化しました",
    catDeletedInUse: "カテゴリを無効化しました（既存の経費データはそのまま保持されます）",
    catConfirmDelete: "「{{name}}」を無効化しますか？既存の経費データは保持されます。",
  },
};

const en = {
  common: {
    appName: "StepHub HR", login: "Login", logout: "Logout", email: "Email", password: "Password",
    save: "Save", cancel: "Cancel", submit: "Submit", edit: "Edit", delete: "Delete",
    approve: "Approve", reject: "Reject", return: "Return", loading: "Loading...",
    home: "Home", dashboard: "Dashboard", back: "Back", search: "Search", export: "Export",
    total: "Total", status: "Status", actions: "Actions", date: "Date", remarks: "Remarks",
    yes: "Yes", no: "No", pending: "Pending", approved: "Approved", rejected: "Rejected", returned: "Returned", draft: "Draft", submitted: "Submitted",
    languageJa: "日本語", languageEn: "English", loginTitle: "Sign in to continue", welcome: "Welcome",
    all: "All", month: "Month", year: "Year", none: "None",
    changePassword: "Change Password", currentPassword: "Current Password", newPassword: "New Password",
    confirmPassword: "Confirm Password", pwMismatch: "Passwords do not match",
    pwChanged: "Password changed", confirm: "Confirm", copy: "Copy", copied: "Copied",
    note: "Note / Comment", requiredNote: "Please enter a reason for return",
    week: "Week",
    download: "Download", openInNewTab: "Open in new tab",
    receipt: "Receipt", noPreview: "Preview is not available for this file type. Please download to view.",
    downloadZip: "Download Receipts (ZIP)", zipEmpty: "No receipts match the filters",
    zipDone: "Downloaded {{count}} receipt(s)",
    zipPreparing: "Preparing ZIP...",
    announcements: "Announcements",
    includeStatus: "Include", statusApprovedOnly: "Approved only", statusApprovedSubmitted: "Approved + Submitted",
    view: "View", saveChanges: "Save Changes",
    phoneNumber: "Phone Number", licenseValidTill: "License Valid Till", hotelMode: "Hotel Mode",
    incentive: "Incentive", gender: "Gender", nationality: "Nationality",
    joiningDate: "Joining Date", relievingDate: "Relieving Date", remarks: "Remarks",
    male: "Male", female: "Female", other: "Other", unspecified: "Unspecified",
    yes: "Yes", no: "No",
    checkExpenses: "Check Expenses", checking: "Checking...", checkColumn: "OCR Check",
    ocrOk: "OK", ocrMismatch: "Amount Mismatch", ocrNoReceipt: "No Receipt",
    ocrFailed: "OCR Failed", ocrManualReview: "Manual Review", ocrNotChecked: "Not checked",
    approveAlertTitle: "Expense mismatch",
    approveAlertBody: "The receipt total does not match the entered amount on {{date}}.\n{{note}}",
    forceApprove: "Force Approve", cancelApprove: "Cancel Approve",
    dateOfBirth: "Date of Birth", age: "Age", nameEn: "Name (English)", address: "Address",
    required: "required", requiredFields: "Please fill the following required fields: {{fields}}",
    saved: "Saved", submitted: "Submitted",
    mandatoryHint: "* indicates a required field",
  },
  driver: {
    home: "Home", clockIn: "Clock In", clockOut: "Clock Out", registerExpense: "Register Expense",
    uploadReceipt: "Upload Receipt", history: "History", todayAttendance: "Today's Attendance", todayExpenses: "Today's Expenses",
    monthlyHours: "Monthly Working Hours", monthlyExpense: "Monthly Expenses", pendingApprovals: "Pending Approvals",
    startTime: "Start Time", endTime: "End Time", breakMinutes: "Break (min)", workingHours: "Working Hours",
    submitAttendance: "Submit Attendance", saveDraft: "Save Draft", noRecords: "No records",
    category: "Category", description: "Description", amount: "Amount", fuel: "Fuel", toll: "Toll", meal: "Meal", other: "Other",
    submitExpense: "Submit Expense", myExpenses: "My Expenses", myAttendance: "My Attendance",
    downloadReport: "Download Report", excel: "Excel", pdf: "PDF",
    receiptsFor: "Receipts",
    registerAttendance: "Register Attendance",
    editingExpense: "Edit Expense", editingRecord: "You are editing this expense",
    saveChanges: "Save Changes", updateAndSubmit: "Update & Submit", editAndResubmit: "Edit & Resubmit",
    resubmitted: "Resubmitted", saved: "Saved",
    returnedHint: "This record was returned. Please edit and resubmit.",
    rejectedHint: "This record was rejected.",
    approvedHint: "Approved records cannot be edited.",
    submitted: "Submitted",
    savedDraft: "Draft saved",
    carNumber: "Car No.",
    kilometers: "Kilometers (km)",
    standbyLabel: "Today is standby (待機)",
    rulesTitle: "Attendance Rules",
    rule1: "Maximum 8 hours/day. Overtime requires approval.",
    rule2: "1-hour lunch break is required.",
    rule3: "For 待機 (standby), a comment must be included in Remarks when submitting.",
    rulesStandbyRequired: "Please enter a comment in Remarks for standby (待機).",
    warnHours: "Over 8 hours. Approval needed.",
    warnBreak: "Break is less than 1 hour.",
  },
  admin: {
    dashboard: "Admin Dashboard", employees: "Employees", attendance: "Attendance Review",
    expenses: "Expense Review", reports: "Reports", totalEmployees: "Total Employees",
    submittedToday: "Submitted Today", missing: "Missing", pendingAtt: "Pending Attendance", pendingExp: "Pending Expenses",
    monthlyExpenseSummary: "Monthly Expense Summary", addEmployee: "Add Employee", empCode: "Employee ID", name: "Name",
    department: "Department", position: "Position", employmentStatus: "Status", joinDate: "Join Date",
    role: "Role", roleDriver: "Driver", roleReportViewer: "Report Viewer", roleHrAdmin: "HR Admin",
    roleHint: "'Report Viewer' is intended for payroll/finance team. They can only download reports.",
    monthlySummary: "Monthly Summary (Excel)", perEmployee: "Per-employee Report",
    reviewNote: "Review Note", filterStatus: "Filter Status", filterEmployee: "Filter Employee",
    filterCategory: "Filter Category",
    seedDemo: "Seed Demo Data", seedDemoHint: "Creates 5 sample drivers and ~1 month of attendance/expenses",
    seeding: "Seeding...", seedDone: "Demo data seeded", seedFailed: "Seeding failed",
    reportType: "Report Type", reportBoth: "Attendance + Expenses", reportAttendance: "Attendance only", reportExpense: "Expenses only",
    activate: "Activate", deactivate: "Deactivate", resetPassword: "Reset Password",
    resetPasswordTitle: "Password Reset", resetPasswordHint: "This new password is shown only once. Please email it to the employee.",
    confirmDeactivate: "Deactivate this employee?", confirmActivate: "Activate this employee?",
    confirmResetPassword: "Reset this employee's password?",
    selectAll: "Select All", clearSelection: "Clear", approveSelected: "Approve Selected",
    confirmBulkApprove: "Approve the selected {{count}} record(s)?",
    bulkApproveDone: "{{count}} record(s) approved",
    noSelection: "Please select at least one record",
    employeeHoursTitle: "Working Hours per Employee (this month)",
    reportDaysWorked: "Days Worked",
    mealWeeklyTitle: "Meal Allowance — Weekly Summary",
    mealWeeklyHint: "¥6,000–¥9,000 / week = within policy (green). Over ¥9,000 = exceeds limit (red).",
    mealOk: "Within policy",
    mealOver: "Exceeds limit",
    mealUnder: "Below range",
    notifications: "Notifications",
    notifSub: "Manage messages shown on driver dashboards.",
    notifNew: "Post New Notification",
    notifPlaceholder: "e.g. There is a special meeting tomorrow at 10:00.",
    notifPost: "Post",
    notifRequired: "Please enter a message",
    notifPosted: "Notification posted",
    notifList: "Active Notifications",
    notifEmpty: "No notifications yet.",
    notifConfirmDelete: "Delete this notification?",
    expenseCategories: "Expense Categories",
    expenseCategoriesSub: "Add, delete, and reorder expense categories. The sort order affects how categories appear in forms and summaries.",
    catNew: "Add New Category",
    catList: "Registered Categories",
    catCode: "Code",
    catCodeHint: "Short internal key (e.g. fuel, parking). Cannot be changed after creation.",
    catLabelJa: "Japanese Label",
    catLabelEn: "English Label",
    catShowInactive: "Show inactive",
    catAllFieldsRequired: "All fields are required",
    catCreated: "Category added",
    catDeleted: "Category deactivated",
    catDeletedInUse: "Category deactivated (existing expense records are preserved)",
    catConfirmDelete: "Deactivate '{{name}}'? Existing expense records will be preserved.",
  },
};

i18n.use(initReactI18next).init({
  resources: { ja: { translation: ja }, en: { translation: en } },
  lng: localStorage.getItem("lang") || "ja",
  fallbackLng: "ja",
  interpolation: { escapeValue: false },
});

export default i18n;
